import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { PopupStore } from '@gem/popups';
import { getFormatNumberToString } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { ReactionsDetailedPopup } from 'APP/main/PopupManager/Popups/ReactionsDetailedPopup/ReactionsDetailedPopup';
import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

interface IMessageViewsPresenter {
  childPopup: PopupStore | null;
  message: ChatMessage;
  isShow: boolean;
  canBeShowPopover: boolean;
  views: string;
  setMessage(message: ChatMessage): void;
  onOpenReactionPopup(): void;
}

export const useMessageViewsPresenter = (message: ChatMessage): IMessageViewsPresenter => {
  const presenter = useLocalObservable<IMessageViewsPresenter>(() => ({
    childPopup: null,
    message,

    get isShow(): boolean {
      return (
        !(presenter.message.group?.withoutMe && presenter.message.group.isClosed) &&
        !presenter.message.isFake &&
        !presenter.message.isFailed &&
        !presenter.message.group?.isFake &&
        !presenter.message.group?.isP2P &&
        !presenter.message.group?.isSavedMessages &&
        Number(presenter.message.views) > 1
      );
    },

    get canBeShowPopover(): boolean {
      const group = presenter.message.group;

      if (!group) {
        return false;
      }

      if (group.isP2P || group.blockedMe) {
        return false;
      }

      if (group.isChannel && !group.withMeInAdmins) {
        return false;
      }

      if (
        'isThread' in group &&
        group['isThread'] &&
        group.parentGroup?.isChannel &&
        !group.parentGroup?.withMeInAdmins
      ) {
        return false;
      }

      return true;
    },

    get views(): string {
      return getFormatNumberToString(presenter.message.views);
    },

    setMessage(message: ChatMessage): void {
      presenter.message = message;
    },

    onOpenReactionPopup(): void {
      presenter.childPopup = Tasks.app.openPopup(ReactionsDetailedPopup, {
        params: { groupId: presenter.message.groupId, messageId: presenter.message.id },
      });
    },
  }));

  useEffect(() => {
    return () => presenter.childPopup?.close();
  }, []);

  useEffect(() => {
    presenter.setMessage(message);
  }, [message]);

  return presenter;
};
